import { observable, action } from "mobx";
import {post,put,get,deleted} from "../services/ajax.service";

class LabelStore {
  @observable labels = [];
  @observable limit = 10;
  @observable tiles = 0;
  @observable action = false;
  @observable reports_response = false
  @observable errors = {};
  @observable reports_availability = {};
  @observable allLabels = [];
  @observable url ="/api/v1/labelactions";
  @observable broker_admin_url ="/api/v1/brokeradminactions";

  @action setErrors = () => {
    this.errors = {};
  };

  @action setAction = action => {
    this.action = action;
  };

  @action getLabels = async data => {
    const entityData = await get(
      `${this.url}/getall?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
    );
    this.labels = entityData.data.rows;
    let count = parseInt(entityData.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;
  };

  @action getAllLabels = async (is_broker_admin = false) => {
    let entityData;
    if(is_broker_admin) {
      entityData = await get(
         `${this.broker_admin_url}/getallLabels`
       );

    }
    else {
      entityData = await get(
        `${this.url}/getallLabels`
      );
    }
      this.allLabels = entityData.data;
  }

  @action deleteLabel = async (id, history) => {
    try {
      await deleted(`${this.url}/delete/${id}`);
      var filtered = this.labels.filter(user => user.id !== id);
      this.labels = filtered;
    } catch (e) {
      console.log(e);
    }
  };

  @action getLabel = async id => {
    const getLabel = await get(`${this.url}/get/${id}`);
    return getLabel.data;
  };
  @action getLabelUsingSlug = async slug => {
    const getLabel = await get(`/api/v1/authactions/getLabelUsingSlug/${slug}`);
    return getLabel.data;
  };
  
  @action addLabel = async (data, history) => {
    try {
      const labelAdd = await post(`${this.url}/create`, data, {
        headers: {
          "Content-Type": "multipart/formdata",
          boundary: "abcdefghijklmnopqrs"
        }});
      this.action = true;
      history.push("/portalmanagement/labels");
    } catch (e) {
      this.errors = e.response.data;
    }
  };

 
  @action editLabel = async (data,id, history) => {
    try {
      await put(`${this.url}/update/${id}`, data,{
        headers: {
          "Content-Type": "multipart/formdata",
          boundary: "abcdefghijklmnopqrs"
        }});
      this.action = true;
      history.push("/portalmanagement/labels");
    } catch (e) {
      this.errors = e.response.data;
    }
  };


  @action get_report_availability = async () => {
    let ReportsData;
    ReportsData = await get(`/api/v1/userentityactions/get_reports_availability`);
      this.reports_availability = ReportsData.data;
  }

  @action change_report_availability = async (data) => {
    try {
      await put(`/api/v1/userentityactions/change_report_availability/${data.id}`, data);
      this.action = true;
      this.reports_response = true
    } catch (e) {
      this.errors = e.response.data;
    }
  };
}

export default LabelStore;
